import { render, staticRenderFns } from "./AdvanceRegistration.vue?vue&type=template&id=5fc7e61c&scoped=true"
import script from "./AdvanceRegistration.vue?vue&type=script&lang=ts"
export * from "./AdvanceRegistration.vue?vue&type=script&lang=ts"
import style0 from "./AdvanceRegistration.vue?vue&type=style&index=0&id=5fc7e61c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc7e61c",
  null
  
)

export default component.exports